import React from 'react';
import logoBp from '../../../estilo/comum/img/logo_samatur_passagens.webp';
import iconSamatur from '../../../estilo/comum/img/icon/logo_samatur_passagens.webp';
import ConteudoQuemSomosA from '../../../componentes/quem-somos/samaturpassagens/ConteudoQuemSomosA';
import dadosSiteComum from './dadosSiteComum';
import cardPrecoPromocao from '../../../estilo/comum/img/carouselCards/samatur_viajar_com_desconto.WEBP';
import cardContrateVexado from '../../../estilo/comum/img/carouselCards/samatur_contrate_o_vexado.webp';
import cardModalPromocao from '../../../estilo/comum/img/carouselCards/samatur_destinos.webp';
import cardQueroAgencia from '../../../estilo/comum/img/carouselCards/samatur_destinos.webp';

const logoBrasilCabecalho = <img className="logo-site brasilp" src={logoBp} alt='Logo Samatur Passagens'/>;
const logoBrasilRodape = <img className="brasilp" src={logoBp} alt="Logo Samatur Passagens" style={{width: '45%'}}/>;


const textoBannerSite = [<h5 key={0} style={{textShadow: '3px 2px black'}}>Passagens online!</h5>, 
    <p key={1} style={{textShadow: '3px 2px black'}}>Um novo jeito de viajar!</p>, 
    <p key={2} style={{textShadow: '3px 2px black'}}>O melhor valor sem precisar sair de casa!</p>];

const textoCardGuiaDicasSite = <p>Não importa se você vai curtir as férias, reencontrar a família ou fazer negócios. Quando o assunto é viagem o mais importante é chegar com conforto e segurança ao destino. Por essa razão, nosso maior propósito é fazer de tudo para que a sua jornada seja inesquecível a bordo de um de nossos amarelinhos.</p>;

export const dadosSamaturpassagens = {
    ...dadosSiteComum,
    id: 'samaturpassagens',
    pastaEstilo: 'samaturpassagens',
    nome: 'Samatur Passagens',
    nomePrefixo: 'o Samatur Passagens',    
    razaoSocial: 'EXPRESSO TRANSPORTE TURISMO E EVENTOS LTDA',
    cnpj: '04.768.381/0001-04',    
    endereco: 'SDMC QD 6 LT 19, Brasília, DF, CEP: 72265-725',
    telefone: '(61) 99623-2761',
    wtpp: '(61) 99623-2761',
    instagram: 'https://www.instagram.com/samatur.oficial',
    facebook: 'https://www.facebook.com/people/SAMATUR-EXPRESSO-TRANSPORTES-TURISMO-E-EVENTOS-LTDA/61577748422485/',
    tiktok: 'https://www.tiktok.com',
    youtube: 'youtube.com',
    email: 'samatur_turismo@hotmail.com',
    emailSuporte: 'samatur_turismo@hotmail.com',
    lkemailSuporte: 'mailto:samatur_turismo@hotmail.com',
    lktelefone: 'tel:5561996232761',
    twitter: '',
    lkemail: 'mailto:samatur_turismo@hotmail.com',
    lkwhats: 'https://api.whatsapp.com/send?phone=5561996232761&text=Olá. Preciso de atendimento.',
    logo: logoBp,
    logoCabecacho: logoBrasilCabecalho,
    logoRodape: logoBrasilRodape,
    OgImage: 'https://imagens-open-graph-sites-agencias.s3.amazonaws.com/amarelinho/via%C3%A7%C3%A3o+amarelinho.webp',
    icone: iconSamatur,
    quemSomos: ConteudoQuemSomosA,
    videoInicio: 'https://imagens-vexado-live.s3.sa-east-1.amazonaws.com/video-backbp2.mp4',
    textoBanner: textoBannerSite,
    textoCardGuiaDicas: textoCardGuiaDicasSite,
    telelefoneAtendimentoDeficienteAuditivoOuFala: '0800 262 7357',
    idsTagManager: ['GTM-NBFGXW3'],
    bannerModalPromocao: 'https://imagens-banner-promocao-sites.s3.us-east-1.amazonaws.com/cupom+de+desconto+SAMATUR.png',    
    cardPrecoPromocao: cardPrecoPromocao,
    cardContrateVexado: cardContrateVexado,
    cardModalPromocao: cardModalPromocao,
    cardQueroAgencia: cardQueroAgencia,
    banner: null,
    bannerMobile: null,
    urlBase: 'https://samaturpassagens.com',
    distribusion: false,
    exibePopUpPromocao: false
};
